let sidebar = {
    $reports: $('#js-sidebarReports'),
    $reportsLists: $('#js-sidebarReportsLists'),
    $reportsTab: $('.js-sidebarReportsTab'),
    classNameTabActive: 'is-active',

    init: function () {
        this.$reportsTab.on('click', this.onTabClick.bind(this))
    },

    onTabClick: function (e) {
        e.preventDefault()

        let list

        list = $(e.target).attr('data-list')
        this.$reportsTab.removeClass(this.classNameTabActive)
        $(e.target).addClass(this.classNameTabActive)
        this.$reportsLists.removeClass('is-new is-popular').addClass(`is-${list}`)
    }
}

export default sidebar